import { render, staticRenderFns } from "./SelectSourceCard.vue?vue&type=template&id=aef7c8b2&scoped=true"
import script from "./SelectSourceCard.vue?vue&type=script&lang=ts"
export * from "./SelectSourceCard.vue?vue&type=script&lang=ts"
import style0 from "./SelectSourceCard.vue?vue&type=style&index=0&id=aef7c8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef7c8b2",
  null
  
)

export default component.exports